module.exports = __webpack_public_path__ + "img/carousel_2.0cb66c05.png";